import React, { useState, memo } from 'react'
import { CommonDatePicker } from '@/components/common'
import {
  SubSection,
  StyledDemoGrid,
  DemoComponent,
  StyledSizeLabel,
} from '../styled.jsx'

export const DatePickerSection = () => {
  const [dateValue, setDateValue] = useState(null)
  const [dateTimeValue, setDateTimeValue] = useState(null)
  const [requiredDate, setRequiredDate] = useState(null)
  const [errorDate, setErrorDate] = useState(null)

  return (
    <>
      {/* Date Picker Variants */}
      <SubSection
        title='Date Picker Variants'
        description='Two main variants: date picker and datetime picker'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Basic Variants
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Date Only'
            component={
              <CommonDatePicker
                id='demo-date-picker'
                label='Select Date'
                value={dateValue}
                onChange={setDateValue}
                variant='date'
                placeholder='Select Date'
              />
            }
            value={dateValue}
          />
          <DemoComponent
            label='Date & Time'
            component={
              <CommonDatePicker
                id='demo-datetime-picker'
                label='Select Date & Time'
                value={dateTimeValue}
                onChange={setDateTimeValue}
                variant='datetime'
              />
            }
            value={dateTimeValue}
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Date Picker Features */}
      <SubSection
        title='Date Picker Features'
        description='Additional features like required fields and validation'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          With Features
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Required Field'
            component={
              <CommonDatePicker
                id='demo-required'
                label='Required Date'
                value={requiredDate}
                onChange={setRequiredDate}
                variant='date'
                required={true}
                helperText='This field is required'
                width='200px'
                fullWidth={false}
              />
            }
            value={requiredDate}
          />
          <DemoComponent
            label='With Error'
            component={
              <CommonDatePicker
                id='demo-error'
                label='Date with Error'
                value={errorDate}
                onChange={setErrorDate}
                variant='date'
                error='Please select a valid date'
                width='200px'
                fullWidth={false}
              />
            }
            value={errorDate}
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Date Picker States */}
      <SubSection
        title='Date Picker States'
        description='Different states: enabled, disabled, and with helper text'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Component States
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Enabled'
            component={
              <CommonDatePicker
                id='demo-enabled'
                label='Enabled Picker'
                value={null}
                onChange={() => {}}
                variant='date'
                width='200px'
                fullWidth={false}
              />
            }
          />
          <DemoComponent
            label='Disabled'
            component={
              <CommonDatePicker
                id='demo-disabled'
                label='Disabled Picker'
                value={new Date()}
                onChange={() => {}}
                variant='date'
                disabled={true}
                width='200px'
                fullWidth={false}
              />
            }
          />
          <DemoComponent
            label='With Helper Text'
            component={
              <CommonDatePicker
                id='demo-helper'
                label='With Helper'
                value={null}
                onChange={() => {}}
                variant='date'
                helperText='Choose your preferred date'
                width='200px'
                fullWidth={false}
              />
            }
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Size Variants */}
      <SubSection
        title='Size Options'
        description='Different width configurations and full-width options'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Width Options
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Small Width'
            component={
              <CommonDatePicker
                id='demo-small'
                label='Small (180px)'
                value={null}
                onChange={() => {}}
                variant='date'
                width='180px'
                fullWidth={false}
              />
            }
          />
          <DemoComponent
            label='Medium Width'
            component={
              <CommonDatePicker
                id='demo-medium'
                label='Medium (240px)'
                value={null}
                onChange={() => {}}
                variant='date'
                width='240px'
                fullWidth={false}
              />
            }
          />
          <DemoComponent
            label='Large Width'
            component={
              <CommonDatePicker
                id='demo-large'
                label='Large (300px)'
                value={null}
                onChange={() => {}}
                variant='date'
                width='300px'
                fullWidth={false}
              />
            }
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
